export default {
  title: 'Mis documentos',
  description: 'Tus documentos empresariales subidos. Puedes descargarlos o reemplazarlos en cualquier momento.',
  document_types: {
    owner_document: 'Documento de identidad del titular',
    business_document: 'Documento empresarial',
  },
  kinds: {
    vat_registration: 'Registro de IVA',
    trade_registration: 'Registro mercantil',
    trade_license: 'Licencia comercial',
    commercial_register_extract: 'Extracto del registro comercial',
    financial_statements: 'Estados financieros',
    bank_statement: 'Extracto bancario',
    shareholder_list: 'Lista de socios',
    other: 'Otro',
    passport: 'Pasaporte',
    driver_license: 'Permiso de conducir',
    id_card: 'DNI',
    residence_permit: 'Permiso de residencia',
  },
  sides: {
    front: 'Anverso',
    back: 'Reverso',
  },
  fields: {
    slot: 'Categoría',
    document: 'Documento',
    kind: 'Tipo',
    side: 'Cara',
    uploaded_at: 'Subido',
    expires_at: 'Vence',
    retained_until: 'Retenido hasta',
    deleted_at: 'Eliminado',
    storage_deleted_at: 'Eliminado permanentemente',
    actions: 'Acciones',
  },
  values: {
    no_slot: 'Otro',
    no_file_name: '—',
    version: 'v{{version}}',
  },
  filters: {
    type_placeholder: 'Filtrar por tipo de documento',
    kind_placeholder: 'Filtrar por tipo',
  },
  retention: {
    deletable: 'Eliminable',
    tooltip:
      'La legislación alemana (GoBD / §147 AO) nos obliga a conservar este documento hasta {{date}}. Solo puede eliminarse después de esa fecha.',
    tooltip_no_date: 'Este documento está sujeto a un período de retención legal y aún no se puede eliminar.',
  },
  buttons: {
    upload: 'Subir',
    upload_other: 'Otro documento',
    retry_slots: 'No se pudieron cargar los documentos; inténtalo de nuevo',
    download: 'Descargar',
    download_front: 'Descargar anverso',
    download_back: 'Descargar reverso',
    reupload: 'Volver a subir',
    delete: 'Eliminar',
  },
  empty: 'Aún no has subido ningún documento.',
  delete_modal: {
    title: 'Eliminar documento',
    description:
      'Elige cómo eliminar este documento. «Eliminar» lo archiva y lo oculta de tu lista. «Eliminar permanentemente» borra los archivos de forma definitiva y solo es posible una vez finalizado el período de retención legal.',
    delete: 'Eliminar',
    permanently_delete: 'Eliminar permanentemente',
    cancel: 'Cancelar',
    retention_alert:
      'Estos documentos están sujetos a períodos de retención legal según la legislación alemana (GoBD / §147 AO). La eliminación permanente de un documento borra sus archivos de forma irreversible.',
  },
  reupload_modal: {
    title: 'Volver a subir documento',
    description: 'Sube una nueva versión de este documento. La versión anterior será reemplazada.',
    type: {
      label: 'Tipo de documento',
      placeholder: 'Seleccionar tipo de documento',
    },
    kind: {
      label: 'Clase de documento',
      placeholder: 'Seleccionar clase de documento',
    },
    front: {
      label: 'Anverso del documento',
    },
    back: {
      label: 'Reverso del documento (opcional para algunos documentos)',
    },
    expires_at: {
      label: 'Fecha de vencimiento del documento',
      placeholder: 'Seleccionar fecha de vencimiento',
    },
    buttons: {
      select_file: 'Seleccionar archivo',
      submit: 'Subir',
      cancel: 'Cancelar',
    },
  },
  toasts: {
    download_error: 'Error al descargar el documento.',
    delete_success: 'Documento eliminado correctamente.',
    delete_error: 'Error al eliminar el documento.',
    reupload_success: 'Documento subido correctamente.',
    reupload_error: 'Error al subir el documento.',
  },
};
